interface IMicrofrontEventSender {
  dispatch(): void;
}

export class MicrofrontEventSender<T> implements IMicrofrontEventSender {
  protected eventName: string;
  protected data?: T;

  public constructor(eventName: string, data?: T) {
    this.eventName = eventName;
    this.data = data;
  }

  public dispatch() {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent<T>(this.eventName, {
          detail: this.data,
        }),
      );
    }
  }
}
